import { KeywordJsEnv } from '../keyword_js_env';

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_SEARCH = new r3_search();
  R3_COMMON.addPlacementType(`search_page.${pageOption.placementNameKeywordNormal}`);
  R3_COMMON.addPlacementType(`search_page.${pageOption.placementNameKeywordLeftSide}`);

  R3_SEARCH.setTerms(pageOption.searchKeyword);
  pageOption.itemIdList.forEach((itemId: string) => R3_SEARCH.addItemId(itemId));
};

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setAddToCartPageRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_SEARCH = new r3_search();
  R3_COMMON.addPlacementType(`add_to_cart_page.${pageOption.placementNameKeywordMyCatalogModal}`);

  R3_SEARCH.setTerms(pageOption.searchKeyword);
  pageOption.itemIdList.forEach((itemId: string) => R3_SEARCH.addItemId(itemId));
};

export const setRrRequestParamsSp = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_SEARCH = new r3_search();
  R3_COMMON.addPlacementType(`search_page.${pageOption.placementNameKeywordSp}`);

  R3_SEARCH.setTerms(pageOption.searchKeyword);
  pageOption.itemIdList.forEach((itemId: string) => R3_SEARCH.addItemId(itemId));
};

export const createRrRequestParam = (model: KeywordJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParams,
    pageOption: {
      placementNameKeywordNormal: model.rrAreaProfileKeywordNormal.placementName,
      placementNameKeywordLeftSide: model.rrAreaProfileKeywordLeftSide.placementName,
      itemIdList: model.itemIdList,
      searchKeyword: model.searchKeyword
    }
  };
};

export const createRrRequestParamSp = (model: KeywordJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParamsSp,
    pageOption: {
      placementNameKeywordSp: model.rrAreaProfileKeywordSp.placementName,
      itemIdList: model.itemIdList,
      searchKeyword: model.searchKeyword
    }
  };
};
